import React from "react";

function CystsAndTumoursOfJaws() {
  return <div>Cysts and Tumours of Jaws</div>;
}

export default CystsAndTumoursOfJaws;
